"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isRequired = function (value) {
    return (value === null || value === void 0 ? void 0 : value.replace(/[^0-9a-zA-Z]/g, '')) ? false : 'Campo obrigatório';
};
exports.default = isRequired;
//# sourceMappingURL=isRequired.js.map